import * as yup from 'yup';

import {
  passedYupValidation,
  passwordYupValidation,
} from 'modules/common/input/FormInput';

export const loginSchema = yup.object({
  email: yup.string().required('Email is required.'),
  password: yup.string().required('Password is required.'),
});

export const signUpSchema = yup.object({
  email_address: yup.string().required('Email is required.'),
  password: yup.string().required('Password is required.'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Password do not match')
    .required('Confirm password is required.'),
});

export const forgotPasswordSchema = yup.object({
  email: yup.string().email().required('Email is required.'),
});

export const resetPasswordSchema = yup.object({
  password: passwordYupValidation(),
  password_passed: passedYupValidation(),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match')
    .required('Confirm Password is required.'),
});

export const passwordExpiredSchema = yup.object({
  old_password: yup.string().required('Current Password is required'),
  password: passwordYupValidation({
    minMessage: `New Password must be atleast 8 characters`,
    requiredMessage: 'New Password is required',
  }),
  password_passed: passedYupValidation(),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match')
    .required('Confirm New Password is required'),
});

export const multiFactorAuthSchema = yup.object({
  otp: yup
    .string()
    .min(6, 'OTP must be at least 6 digits')
    .max(6, 'OTP must not exceed 6 digits')
    .required('OTP is required.'),
});

export const registerSchema = yup.object({
  business_name: yup.string().required('Store Name is required.'),
  first_name: yup.string().required('First Name is required.'),
  last_name: yup.string().required('Last Name is required.'),
  email_address: yup
    .string()
    .email('Email Address must be a valid email.')
    .required('Email Address is required.'),
  mobile_number: yup.string().required('Mobile Number is required.'),
  password: passwordYupValidation(),
  password_passed: passedYupValidation(),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match')
    .required('Confirm Password is required.'),
});
